import { Building2, MapPin, Wrench } from 'lucide-react';
import { Link } from 'react-router-dom';

function About() {
  return (
    <div className="pt-28">
      {/* Hero Section with Powerful Opening */}
      <section className="bg-black py-32 relative overflow-hidden" data-testid="about-section">
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="absolute inset-0 shimmer-wave"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <span className="text-gold text-sm font-semibold tracking-[0.3em] uppercase mb-4 block">About Us</span>
            <div className="w-24 h-1 bg-gold mx-auto mb-12"></div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8 leading-tight font-serif max-w-5xl mx-auto" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>
              Your Vision. Our <span className="text-gold">Integrity</span>. Exceptional Results.
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 leading-relaxed max-w-4xl mx-auto mb-12">
              Williams Diversified LLC is a mission-driven, rapid-deployment contractor serving both the private and public sectors with uncompromising reliability—<span className="text-gold font-semibold">nationwide and worldwide</span>.
            </p>
          </div>

          <div className="max-w-5xl mx-auto">
            <div className="bg-black border border-gold/30 rounded-lg p-10 mb-12">
              <p className="text-gray-300 text-lg leading-relaxed mb-6">
                Headquartered in <span className="text-gold font-semibold">Tulsa, Oklahoma</span>, we deliver high-impact solutions across Base Operations Support, emergency response, logistics, facility services, and commercial construction with a focus on speed, accountability, and excellence.
              </p>
              <p className="text-gray-300 text-lg leading-relaxed">
                Our company was built on a simple but powerful foundation: <span className="text-white font-semibold">do the right thing, deliver the hard things, and always stand behind the work</span>. With deep experience in both field operations and strategic leadership, Williams Diversified LLC was established to meet a global demand for contractors who can move fast, communicate clearly, and perform with discipline in environments where delays are not an option.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="bg-black py-32 relative overflow-hidden border-t border-gold/30">
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="absolute inset-0 shimmer-wave"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-4xl md:text-5xl font-bold text-white mb-6 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>
              Why Choose <span className="text-gold">Williams Diversified</span>
            </h3>
            <div className="w-24 h-1 bg-gold mx-auto mb-8"></div>
          </div>
          
          <div className="grid md:grid-cols-2 gap-10 max-w-6xl mx-auto">
            <div className="relative overflow-hidden rounded-lg border-2 border-gold/30 hover:border-gold transition-all group hover:transform hover:scale-105 hover:shadow-2xl min-h-[280px] bg-transparent">
              <div className="p-10">
                <div className="text-gold mb-6 group-hover:scale-110 transition-transform">
                  <Building2 className="w-16 h-16" />
                </div>
                <h4 className="text-white font-bold text-3xl mb-4 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>
                  Rapid Deployment
                </h4>
                <ul className="text-gray-300 text-lg space-y-2">
                  <li className="flex items-start">
                    <span className="text-gold mr-3">•</span>
                    <span>48-hour mobilization</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-gold mr-3">•</span>
                    <span>Nationwide & worldwide reach</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-gold mr-3">•</span>
                    <span>Emergency response ready</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="relative overflow-hidden rounded-lg border-2 border-gold/30 hover:border-gold transition-all group hover:transform hover:scale-105 hover:shadow-2xl min-h-[280px] bg-transparent">
              <div className="p-10">
                <div className="text-gold mb-6 group-hover:scale-110 transition-transform">
                  <Wrench className="w-16 h-16" />
                </div>
                <h4 className="text-white font-bold text-3xl mb-4 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>
                  Full-Spectrum Support
                </h4>
                <ul className="text-gray-300 text-lg space-y-2">
                  <li className="flex items-start">
                    <span className="text-gold mr-3">•</span>
                    <span>Base operations & facility services</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-gold mr-3">•</span>
                    <span>Construction & logistics</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-gold mr-3">•</span>
                    <span>Integrated solutions</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="relative overflow-hidden rounded-lg border-2 border-gold/30 hover:border-gold transition-all group hover:transform hover:scale-105 hover:shadow-2xl min-h-[280px] bg-transparent">
              <div className="p-10">
                <div className="text-gold mb-6 group-hover:scale-110 transition-transform">
                  <MapPin className="w-16 h-16" />
                </div>
                <h4 className="text-white font-bold text-3xl mb-4 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>
                  Global Reach
                </h4>
                <ul className="text-gray-300 text-lg space-y-2">
                  <li className="flex items-start">
                    <span className="text-gold mr-3">•</span>
                    <span>50+ states covered</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-gold mr-3">•</span>
                    <span>International operations</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-gold mr-3">•</span>
                    <span>Local precision, global scale</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="relative overflow-hidden rounded-lg border-2 border-gold/30 hover:border-gold transition-all group hover:transform hover:scale-105 hover:shadow-2xl min-h-[280px] bg-transparent">
              <div className="p-10">
                <div className="text-gold mb-6 group-hover:scale-110 transition-transform">
                  <Building2 className="w-16 h-16" />
                </div>
                <h4 className="text-white font-bold text-3xl mb-4 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>
                  Mission-Critical
                </h4>
                <ul className="text-gray-300 text-lg space-y-2">
                  <li className="flex items-start">
                    <span className="text-gold mr-3">•</span>
                    <span>High-stakes environments</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-gold mr-3">•</span>
                    <span>Zero-delay commitment</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-gold mr-3">•</span>
                    <span>Unwavering reliability</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Values Section */}
      <section className="bg-black py-32 relative overflow-hidden border-t border-gold/30">
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-4xl md:text-5xl font-bold text-white mb-6 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>
              Our <span className="text-gold">Core Values</span>
            </h3>
            <div className="w-24 h-1 bg-gold mx-auto mb-8"></div>
          </div>
          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            <div className="bg-black border border-gold/30 rounded-lg p-8 hover:border-gold transition-all">
              <div className="flex items-start space-x-4 mb-4">
                <span className="text-gold text-3xl font-bold">1</span>
                <h4 className="text-2xl font-bold text-gold">Integrity Above All</h4>
              </div>
              <p className="text-gray-300 leading-relaxed pl-12">
                We operate with honesty, transparency, and professionalism—serving as a trusted partner from project kickoff to final documentation.
              </p>
            </div>

            <div className="bg-black border border-gold/30 rounded-lg p-8 hover:border-gold transition-all">
              <div className="flex items-start space-x-4 mb-4">
                <span className="text-gold text-3xl font-bold">2</span>
                <h4 className="text-2xl font-bold text-gold">Reliability in High-Stakes Environments</h4>
              </div>
              <p className="text-gray-300 leading-relaxed pl-12">
                Across the country or across the globe, our teams execute with discipline under pressure. Timelines are met. Standards are upheld. Results are delivered.
              </p>
            </div>

            <div className="bg-black border border-gold/30 rounded-lg p-8 hover:border-gold transition-all">
              <div className="flex items-start space-x-4 mb-4">
                <span className="text-gold text-3xl font-bold">3</span>
                <h4 className="text-2xl font-bold text-gold">Service-Driven Leadership</h4>
              </div>
              <p className="text-gray-300 leading-relaxed pl-12">
                We believe leadership is service. Every project—federal, commercial, or international—receives the same level of commitment, communication, and accountability.
              </p>
            </div>

            <div className="bg-black border border-gold/30 rounded-lg p-8 hover:border-gold transition-all">
              <div className="flex items-start space-x-4 mb-4">
                <span className="text-gold text-3xl font-bold">4</span>
                <h4 className="text-2xl font-bold text-gold">Results You Can Measure</h4>
              </div>
              <p className="text-gray-300 leading-relaxed pl-12">
                We were founded on performance. Our systems ensure accuracy, compliance, safety, and clear reporting at every stage of execution.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Mission Section */}
      <section className="bg-black py-32 relative overflow-hidden border-t border-gold/30">
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h3 className="text-4xl md:text-5xl font-bold text-white mb-8 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>
              Our <span className="text-gold">Mission</span>
            </h3>
            <div className="w-24 h-1 bg-gold mx-auto mb-12"></div>
            <p className="text-xl md:text-2xl text-gray-300 leading-relaxed mb-12">
              To deliver rapid, dependable, and expertly executed support services for partners and communities around the world—<span className="text-gold font-semibold">wherever the mission demands</span>.
            </p>
          </div>
          
          <div className="bg-black border border-gold/30 rounded-lg p-10">
            <h4 className="text-3xl font-bold text-white mb-6 text-center font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>
              The <span className="text-gold">Williams Diversified Advantage</span>
            </h4>
            
            <p className="text-gray-300 text-lg leading-relaxed text-center mb-6">
              We know you have options when it comes to choosing a contractor. And we also know that choosing the wrong one can mean missed deadlines, budget overruns, and sleepless nights wondering if the job will get done right. That's exactly why Williams Diversified LLC exists—to be the partner you can count on when everything is on the line.
            </p>
            
            <p className="text-gray-300 text-lg leading-relaxed text-center mb-6">
              When you work with us, you're not just hiring a contractor—you're gaining a dedicated team that genuinely cares about your success. We take the time to understand your vision, your challenges, and your goals. Whether you're managing a federal facility that requires strict compliance, overseeing a commercial buildout with a tight timeline, or coordinating a nationwide rollout across multiple locations, we bring the same level of commitment, professionalism, and attention to detail to every single project.
            </p>
            
            <p className="text-gray-300 text-lg leading-relaxed text-center mb-8">
              Our clients don't just appreciate our work—they trust us. They trust us because we show up when we say we will. We communicate clearly and proactively, so you're never left wondering about the status of your project. We solve problems before they become crises. And we deliver results that speak for themselves, time and time again.
            </p>

            <div className="grid md:grid-cols-2 gap-6 mb-8">
              <div className="text-center p-6 border border-gold/20 rounded-lg hover:border-gold/50 transition-all">
                <p className="text-gold font-bold text-xl mb-3">Rapid Response, Real Results</p>
                <p className="text-gray-400">With 48-hour deployment capability, we mobilize quickly so your project stays on schedule. When time is critical, we deliver—without compromising quality.</p>
              </div>
              <div className="text-center p-6 border border-gold/20 rounded-lg hover:border-gold/50 transition-all">
                <p className="text-gold font-bold text-xl mb-3">Your Dedicated Team</p>
                <p className="text-gray-400">No call centers. No runaround. You'll have a single point of contact who knows your project inside and out and is always just a phone call away.</p>
              </div>
              <div className="text-center p-6 border border-gold/20 rounded-lg hover:border-gold/50 transition-all">
                <p className="text-gold font-bold text-xl mb-3">Honest, Transparent Pricing</p>
                <p className="text-gray-400">We believe in earning your trust through transparency. Our quotes are detailed and accurate—no hidden fees, no surprise charges, no games.</p>
              </div>
              <div className="text-center p-6 border border-gold/20 rounded-lg hover:border-gold/50 transition-all">
                <p className="text-gold font-bold text-xl mb-3">A Track Record You Can Verify</p>
                <p className="text-gray-400">Government-certified, fully insured, and backed by years of successful projects. We're proud of our reputation and we work hard every day to maintain it.</p>
              </div>
            </div>
            
            <div className="bg-gold/10 border border-gold/30 rounded-lg p-8 text-center">
              <p className="text-white text-xl leading-relaxed mb-4">
                At the end of the day, we measure our success by yours. When your project is completed on time, within budget, and exceeds expectations—that's when we know we've done our job right.
              </p>
              <p className="text-gold text-lg font-semibold">
                Ready to experience what it's like to work with a contractor who truly has your back? We'd love to hear about your project.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-black py-24 relative overflow-hidden border-t border-gold/30">
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <h3 className="text-4xl md:text-5xl font-bold text-white mb-6 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>
            Let's Build Something <span className="text-gold">Amazing Together</span>
          </h3>
          <p className="text-gray-300 text-xl mb-10">
            Discover how our experience and commitment to excellence can transform your next project.
          </p>
          <Link 
            to="/contact"
            className="inline-block bg-gold hover:bg-gold-dark text-black font-bold py-5 px-12 rounded text-lg transition-all transform hover:scale-105 uppercase tracking-wider"
          >
            Contact Us Today
          </Link>
        </div>
      </section>
    </div>
  );
}

export default About;
